// Editorial article body — wide:/small:/medium:/noborder:/caption pass over
// RTE images (PRD §4.3, §8). Progressive enhancement: without this running,
// images simply render at column width, with a border, no caption.
// wide:/small:/medium: are mutually exclusive size prefixes (checked in that
// order) — at most one applies. noborder: can follow any of them, or stand
// alone, e.g. "small:noborder:Caption text".
document.querySelectorAll('.editorial-body img').forEach((img) => {
  let alt = img.getAttribute('alt') || '';
  const isWide = alt.startsWith('wide:');
  if (isWide) alt = alt.slice(5);
  const isSmall = !isWide && alt.startsWith('small:');
  if (isSmall) alt = alt.slice(6);
  const isMedium = !isWide && !isSmall && alt.startsWith('medium:');
  if (isMedium) alt = alt.slice(7);
  const noBorder = alt.startsWith('noborder:');
  if (noBorder) alt = alt.slice(9);
  const captionText = alt.trim();

  const figure = document.createElement('figure');
  if (isWide) figure.classList.add('editorial-body__figure--wide');
  if (isSmall) figure.classList.add('editorial-body__figure--small');
  if (isMedium) figure.classList.add('editorial-body__figure--medium');
  if (noBorder) figure.classList.add('editorial-body__figure--no-border');

  // Only replace the whole <p> if this image is its sole content — never a
  // shared paragraph (multiple images, or image mixed with text), which
  // would delete unrelated sibling content. Otherwise replace just the img.
  const parent = img.parentElement;
  const soleContent = parent && parent.tagName === 'P' && parent.children.length === 1 && parent.textContent.trim() === '';
  const target = soleContent ? parent : img;

  target.replaceWith(figure);
  figure.appendChild(img);
  img.setAttribute('alt', captionText);

  if (captionText) {
    const figcaption = document.createElement('figcaption');
    figcaption.textContent = captionText;
    figure.appendChild(figcaption);
  }
});

// ONE-OFF HARDCODE — article "barpiatto" only (2026-07-21, revised 2026-07-22:
// the "EFTER" heading was edited from H2 to H1 in the RTE, so the lookup now
// matches either tag). Background/text/image-border colors ease from the
// article's own black/white metafield values to white/black as the body's
// "EFTER" heading enters the viewport, and STAY shifted once scrolled past
// it going down — only easing back to the original values if the reader
// scrolls back up above "EFTER" again.
// Captures each target's starting --color-bg/--color-text before ever
// changing them, since removing an inline custom property would fall
// through to the site's default tokens, not back to the metafield-set
// starting values.
// Finds the heading by its text content (not DOM position) — more robust
// than a CSS structural selector, survives the body being restructured as
// long as the heading still says "EFTER". No-ops entirely on every other
// article (barpiattoBody is null). Actual easing is plain CSS transition —
// see editorial.css. The two .editorial-article-transition bands (the 12px
// gradient seams against the global header/footer) are included too, so
// they don't get left behind showing the old color — but their background
// is a gradient, and browsers can't smoothly transition between two
// gradients (a real CSS limitation, not something stylable around), so
// those two specifically jump instantly rather than easing like the rest.
// To remove: delete this block + the CSS transition rules +
// the barpiatto_shift_class/barpiatto_body_class Liquid checks.
const barpiattoBody = document.querySelector('.editorial-body--barpiatto');
if (barpiattoBody) {
  const heading = [...barpiattoBody.querySelectorAll('h1, h2')].find(
    (h) => h.textContent.trim().toUpperCase() === 'EFTER'
  );
  if (heading) {
    const shiftTargets = document.querySelectorAll(
      '.editorial-article-header--barpiatto-shift, .editorial-article-body-wrap--barpiatto-shift, .editorial-article-transition'
    );
    const originalColors = new Map();
    shiftTargets.forEach((el) => {
      originalColors.set(el, {
        bg: el.style.getPropertyValue('--color-bg'),
        text: el.style.getPropertyValue('--color-text'),
      });
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Stay shifted once scrolled past "EFTER" going down (its box has
        // scrolled above the viewport — top < 0) even though it's no longer
        // intersecting. Only revert if it's below the viewport (not yet
        // reached, or scrolled back up past it going the other way).
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        const shifted = entry.isIntersecting || scrolledPast;
        shiftTargets.forEach((el) => {
          if (shifted) {
            el.style.setProperty('--color-bg', '#ffffff');
            el.style.setProperty('--color-text', '#000000');
          } else {
            const original = originalColors.get(el);
            el.style.setProperty('--color-bg', original.bg);
            el.style.setProperty('--color-text', original.text);
          }
        });
      });
    });
    observer.observe(heading);
  }
}
